var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationFavoriteChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 17.3334V12.0001M20 2.66675H12C5.33329 2.66675 2.66663 5.33342 2.66663 12.0001V20.0001C2.66663 26.6667 5.33329 29.3334 12 29.3334H17.3333",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.4998C18.6 14.4731 14.08 18.2333 9 19.5",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7466 10H22.6533V13.8933",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9733 21.0932L26.3466 21.8532C26.5333 22.2265 26.9999 22.5732 27.4133 22.6532L27.92 22.7332C29.44 22.9865 29.8 24.1065 28.7066 25.2132L28.2399 25.6798C27.9333 25.9998 27.76 26.6132 27.8533 27.0398L27.92 27.3198C28.3333 29.1598 27.36 29.8665 25.76 28.9065L25.4133 28.7065C24.9999 28.4665 24.3333 28.4665 23.92 28.7065L23.5733 28.9065C21.9599 29.8798 20.9866 29.1598 21.4133 27.3198L21.4799 27.0398C21.5733 26.6132 21.4 25.9998 21.0933 25.6798L20.6266 25.2132C19.5333 24.1065 19.8933 22.9865 21.4133 22.7332L21.92 22.6532C22.32 22.5865 22.7999 22.2265 22.9866 21.8532L23.3599 21.0932C24.0799 19.6398 25.2533 19.6398 25.9733 21.0932Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 9.37012C29.9853 9.37012 32 7.3554 32 4.87012C32 2.38484 29.9853 0.370117 27.5 0.370117C25.0147 0.370117 23 2.38484 23 4.87012C23 7.3554 25.0147 9.37012 27.5 9.37012Z",
    fill: "#828ECC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationFavoriteChart);
export default __webpack_public_path__ + "static/media/notification-favorite-chart.7d633c8b.svg";
export { ForwardRef as ReactComponent };